import React, {Component} from "react";

export class AlertTooltip extends Component {
    render() {
        let tooltipContent = this.tooltipContent();
        return (
            <div className="alert-tooltip">
                <div className="alert-tooltip-marker">
                    <i className="fa fa-circle" aria-hidden="true"/>
                </div>
                <div className="alert-tooltip-body">
                    <div className="alert-tooltip-header">
                        <p className="alert-tooltip-title">{this.props.comparisonWithAverageValue}</p>
                        {/*<div className="alert-tooltip-options">*/}
                        {/*<button className="snooze-button"></button>*/}
                        {/*</div>*/}
                    </div>
                    {tooltipContent}
                </div>
            </div>

        )
    }

    tooltipContent() {
        let day;
        if (this.props.trackConversionsUsingAnalytics) {
            day = "ayer";
        } else {
            day = "hoy";
        }
        return (
            <div className="alert-tooltip-content">
                <p className="alert-tooltip-metric">
                    {`${this.props.metricValue} ${this.props.metricName} ${day}`}
                </p>
                <p className="alert-tooltip-description">
                    {`Esta cuenta tuvo ${this.props.metricValue} de ${this.props.metricName} ${day}
                    y ${this.props.metricExpextedValue} en el pasado.`}
                </p>
                {this.renderGoogleAnalyticsNotice()}
                <p>
                    {this.renderHasNoActionsSelectedNotice()}
                </p>
            </div>
        );
    }

    renderGoogleAnalyticsNotice() {
        if (this.props.trackConversionsUsingAnalytics) {
            return (
                <p className="alert-tooltip-description">
                    Nota: Los datos obtenidos de Google Analytics tienen 1 día de retraso.
                </p>
            )
        } else {
            return null;
        }
    }
    
    renderHasNoActionsSelectedNotice() {
        if (this.props.hasMetaActionsAndAreNotSet) {
            return (
                <p className="alert-tooltip-description">
                    Para poder monitorear correctamente las conversiones y su CPA deberás seleccionar al menos una acción de conversión. Para eso, ve a editar la línea de control, luego a la solapa Cuentas y ahí configura las conversiones en cada cuenta de Meta Ads.
                </p>
            )
        } else {
            return null;
        }
    }
}
